import React from "react";
import cn from "classnames";
import _ from "lodash";
import { Modal } from "../../../ui/Modal";
import { useDispatch } from "react-redux";
import { consultationHistoryLogToggle } from "../../../../actions/chartSideMedicalFillInFormActions";

import { getCompanyFormatFullDate } from "../../../../helpers/DateUtils";

const ConsultationHistoryModal = ({ show, consultationHistory = [] }) => {
  const dispatch = useDispatch();

  const onClose = () => dispatch(consultationHistoryLogToggle(false));

  return (
    <Modal
      dialogClassName="p-0"
      show={show}
      onHide={onClose}
      actions={
        <button type="button" className="btn btn-success" onClick={onClose}>
          Ok
        </button>
      }
    >
      <div
        className={cn("medical-fill-in-form-history", {
          "medical-fill-in-form-history--border": consultationHistory.length,
        })}
      >
        <div className="medical-fill-in-form-history__header">
          <div className="history-item header-item --border">Created by</div>
          <div className="history-item header-item">Created on</div>
        </div>
        {consultationHistory.map((item, idx) => (
          <div key={idx} className="medical-fill-in-form-history__body">
            <div className="history-item --border">{_.get(item, ["creator", "name"], "---")}</div>
            <div className="history-item">
              {getCompanyFormatFullDate(_.get(item, "createdDate"))}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default ConsultationHistoryModal;
